export const categories = [
  { slug: 'romance', name: '浪漫爱情', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-magic-line' },
  { slug: 'action', name: '热血动作', icon: 'ri-fire-line' },
  { slug: 'drama', name: '都市剧情', icon: 'ri-building-line' },
  { slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line' },
  { slug: 'thriller', name: '悬疑惊悚', icon: 'ri-ghost-line' },
  { slug: 'historical', name: '历史古风', icon: 'ri-ancient-gate-line' },
  { slug: 'school', name: '校园青春', icon: 'ri-book-open-line' },
];

export const comics = [
  {
    id: 1,
    slug: 'queen-of-tears',
    title: '眼泪女王',
    author: '李智恩',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20romantic%20couple%20in%20soft%20pastel%20colors%2C%20elegant%20character%20design%2C%20emotional%20atmosphere%2C%20webtoon%20art%20style%2C%20clean%20composition%2C%20soft%20lighting%2C%20minimal%20background%20with%20floral%20elements&width=600&height=800&seq=comic-01&orientation=portrait',
    description: '一个是冷血无情的财阀千金，一个是温柔坚韧的平民律师。当婚姻成为交易，爱情却在不经意间悄然滋生。一场意外让两人的身份发生逆转，曾经高高在上的她跌落凡尘，而他成为了她唯一的依靠。在泪水中绽放的爱情之花，能否经受住命运的考验？',
    rating: 9.2,
    views: 1280000,
    chapters: 86,
    status: '连载中',
    tags: ['爱情', '财阀', '契约婚姻', '虐心'],
    updatedAt: '2026-08-04',
  },
  {
    id: 2,
    slug: 'sword-master',
    title: '剑尊归来',
    author: '朴泰俊',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20action%20illustration%20of%20a%20sword%20warrior%20with%20flowing%20dark%20hair%2C%20wielding%20a%20glowing%20sword%2C%20dynamic%20pose%2C%20martial%20arts%20theme%2C%20dramatic%20lighting%2C%20webtoon%20art%20style%2C%20clean%20background%20with%20energy%20effects&width=600&height=800&seq=comic-02&orientation=portrait',
    description: '一代剑尊渡劫失败，重生回到少年时代。带着前世三百年的记忆与剑道感悟，他誓要改写命运的轨迹。昔日仇敌尚未崛起，挚爱之人仍在水深火热之中。这一次，他不会再让悲剧重演。一剑在手，天下我有！',
    rating: 9.5,
    views: 2560000,
    chapters: 152,
    status: '连载中',
    tags: ['重生', '武侠', '热血', '战斗'],
    updatedAt: '2026-08-05',
  },
  {
    id: 3,
    slug: 'office-romance',
    title: '社内恋爱',
    author: '韩素希',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20office%20romance%20illustration%2C%20young%20professional%20couple%20in%20modern%20office%20setting%2C%20chic%20fashion%2C%20romantic%20tension%2C%20webtoon%20art%20style%2C%20warm%20ambient%20lighting%2C%20clean%20composition&width=600&height=800&seq=comic-03&orientation=portrait',
    description: '在首尔最顶尖的广告公司里，她是刚入职的新人设计师，他则是公司里最年轻有为的创意总监。两个性格迥异的人在一次次项目中碰撞出火花。然而办公室恋情从来都不简单——同事的闲言碎语、上司的质疑、竞争对手的挑拨……他们的爱情能否在职场丛林中生存？',
    rating: 8.9,
    views: 980000,
    chapters: 64,
    status: '连载中',
    tags: ['职场', '办公室恋情', '都市', '甜宠'],
    updatedAt: '2026-08-03',
  },
  {
    id: 4,
    slug: 'magic-school',
    title: '魔法学院的劣等生',
    author: '金贤秀',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20fantasy%20illustration%20of%20a%20magic%20student%20in%20a%20magical%20academy%2C%20wearing%20robes%2C%20magical%20sparks%20around%2C%20mysterious%20atmosphere%2C%20webtoon%20art%20style%2C%20dark%20academia%20vibe%2C%20clean%20composition&width=600&height=800&seq=comic-04&orientation=portrait',
    description: '在所有人都拥有强大魔法天赋的世界里，他是唯一一个被鉴定为"零魔力"的劣等生。然而，当古老的预言开始应验，当黑暗势力蠢蠢欲动，人们才惊恐地发现——他不是没有魔力，而是拥有着禁忌的"反魔力"。这个被所有人看不起的少年，将如何改写世界的法则？',
    rating: 9.1,
    views: 1850000,
    chapters: 98,
    status: '连载中',
    tags: ['魔法', '学院', '逆袭', '奇幻'],
    updatedAt: '2026-08-04',
  },
  {
    id: 5,
    slug: 'daily-laugh',
    title: '社畜的搞笑日常',
    author: '崔宇植',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20comedy%20illustration%20of%20a%20funny%20office%20worker%20with%20exaggerated%20expressions%2C%20cartoonish%20style%2C%20humorous%20situation%2C%20webtoon%20art%20style%2C%20bright%20colors%2C%20clean%20composition&width=600&height=800&seq=comic-05&orientation=portrait',
    description: '普通上班族金大韩的爆笑日常！每天早上与闹钟的斗争、地铁上的奇葩遭遇、办公室里让人哭笑不得的同事、加班到深夜的崩溃瞬间……每一个社畜都能在这里找到自己的影子。笑着笑着，你会发现——原来我们都是这样活着。',
    rating: 9.0,
    views: 1560000,
    chapters: 120,
    status: '连载中',
    tags: ['搞笑', '日常', '职场', '治愈'],
    updatedAt: '2026-08-05',
  },
  {
    id: 6,
    slug: 'dark-secret',
    title: '暗影追踪',
    author: '尹世雅',
    category: 'thriller',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20thriller%20illustration%20with%20dark%20moody%20atmosphere%2C%20detective%20character%20in%20rainy%20night%2C%20mysterious%20silhouette%2C%20film%20noir%20vibe%2C%20webtoon%20art%20style%2C%20dramatic%20shadows%2C%20clean%20composition&width=600&height=800&seq=comic-06&orientation=portrait',
    description: '首尔连续发生离奇失踪案件，所有线索都指向一个早已被关闭的精神病院。刑警韩智雅深入调查，却发现自己与这些案件有着不可思议的联系。记忆中的碎片、诡异的符号、隐藏在暗处的眼睛……真相远比想象中更加恐怖。',
    rating: 9.3,
    views: 1120000,
    chapters: 72,
    status: '连载中',
    tags: ['悬疑', '推理', '惊悚', '犯罪'],
    updatedAt: '2026-08-02',
  },
  {
    id: 7,
    slug: 'joseon-romance',
    title: '朝鲜王朝秘史',
    author: '朴叙俊',
    category: 'historical',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20historical%20romance%20illustration%2C%20Joseon%20era%20noble%20couple%20in%20traditional%20hanbok%2C%20palace%20background%2C%20elegant%20and%20refined%2C%20webtoon%20art%20style%2C%20soft%20warm%20lighting%2C%20clean%20composition&width=600&height=800&seq=comic-07&orientation=portrait',
    description: '朝鲜时代，她是出身卑微的医女，他是权倾朝野的世子。在宫廷的权力斗争中，两个本不该相遇的人命运交织。她以医术救人，他以仁政治国。然而，一场阴谋正在暗中酝酿——他们的爱情，将改变整个王朝的命运。',
    rating: 9.0,
    views: 890000,
    chapters: 58,
    status: '连载中',
    tags: ['古风', '宫斗', '爱情', '历史'],
    updatedAt: '2026-08-01',
  },
  {
    id: 8,
    slug: 'campus-love',
    title: '我们的夏天',
    author: '林秀晶',
    category: 'school',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20youth%20romance%20illustration%2C%20high%20school%20students%20in%20summer%2C%20cherry%20blossom%20background%2C%20fresh%20and%20youthful%2C%20webtoon%20art%20style%2C%20bright%20and%20warm%20lighting%2C%20clean%20composition&width=600&height=800&seq=comic-08&orientation=portrait',
    description: '高三的最后一个夏天，学霸班长和校草不良少年被安排成了同桌。一个只知道学习，一个只知道打架，两个完全不同世界的人开始了啼笑皆非的同桌生活。从互相看不顺眼到偷偷心动，青春的悸动在蝉鸣声中悄然绽放。',
    rating: 8.8,
    views: 1350000,
    chapters: 45,
    status: '连载中',
    tags: ['校园', '青春', '甜宠', '成长'],
    updatedAt: '2026-08-04',
  },
  {
    id: 9,
    slug: 'dungeon-hunter',
    title: '地下城猎人',
    author: '郑雨盛',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20dungeon%20adventure%20illustration%2C%20hunter%20character%20with%20armor%20and%20weapons%2C%20dark%20dungeon%20setting%20with%20magical%20glow%2C%20action%20pose%2C%20webtoon%20art%20style%2C%20dramatic%20lighting%2C%20clean%20composition&width=600&height=800&seq=comic-09&orientation=portrait',
    description: '世界各地突然出现神秘的地下城，只有拥有特殊能力的"猎人"才能进入探索。曾经是最弱E级猎人的成宇，在一次濒死体验中觉醒了隐藏的SSS级能力——"掠夺"。从此，他开始了一段逆袭成王的传奇之路。',
    rating: 9.6,
    views: 3200000,
    chapters: 178,
    status: '连载中',
    tags: ['地下城', '升级', '热血', '奇幻'],
    updatedAt: '2026-08-05',
  },
  {
    id: 10,
    slug: 'cafe-sunrise',
    title: '日出咖啡馆',
    author: '金多美',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20slice%20of%20life%20illustration%2C%20cozy%20cafe%20setting%20with%20warm%20sunlight%2C%20barista%20character%2C%20relaxing%20atmosphere%2C%20webtoon%20art%20style%2C%20soft%20natural%20lighting%2C%20clean%20composition&width=600&height=800&seq=comic-10&orientation=portrait',
    description: '辞去大公司工作后，素英在首尔的小巷里开了一家小小的咖啡馆。每天清晨，不同的客人带着不同的故事走进来——失恋的女孩、迷茫的大学生、孤独的老人……一杯咖啡的时间里，素英倾听着他们的故事，也在这个小小的空间里，重新找到了生活的意义。',
    rating: 9.1,
    views: 780000,
    chapters: 42,
    status: '连载中',
    tags: ['治愈', '日常', '咖啡', '人生'],
    updatedAt: '2026-08-03',
  },
  {
    id: 11,
    slug: 'spirit-contract',
    title: '灵契之约',
    author: '金泰亨',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20supernatural%20fantasy%20illustration%2C%20character%20with%20spirit%20familiar%2C%20ethereal%20glowing%20elements%2C%20mystical%20atmosphere%2C%20webtoon%20art%20style%2C%20soft%20magical%20lighting%2C%20clean%20composition&width=600&height=800&seq=comic-11&orientation=portrait',
    description: '能看见鬼魂的大学生智勋，某天意外与一位强大的古代灵体签订了契约。从此他被迫卷入灵界与人间的纷争之中。跟随他的灵体们，有的曾是将军，有的是诗人，有的是被遗忘的神祇。在这场跨越千年的战斗中，智勋逐渐揭开了一个足以改变世界的秘密。',
    rating: 8.7,
    views: 670000,
    chapters: 55,
    status: '连载中',
    tags: ['灵异', '契约', '奇幻', '冒险'],
    updatedAt: '2026-07-30',
  },
  {
    id: 12,
    slug: 'love-game',
    title: '恋爱游戏',
    author: '李圣经',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20romantic%20comedy%20illustration%2C%20young%20couple%20playing%20video%20games%20together%2C%20playful%20mood%2C%20colorful%20and%20bright%2C%20webtoon%20art%20style%2C%20clean%20composition&width=600&height=800&seq=comic-12&orientation=portrait',
    description: '职业电竞选手姜泰浩，在游戏中遇到了他的"宿敌"——一个技术超群却从不露面的神秘玩家。在一次线下比赛中，他惊讶地发现，这个让他又爱又恨的对手竟然是个甜美可爱的女生。从此，游戏世界的较量变成了现实中的甜蜜拉扯。',
    rating: 8.6,
    views: 920000,
    chapters: 38,
    status: '连载中',
    tags: ['电竞', '恋爱', '甜宠', '搞笑'],
    updatedAt: '2026-08-04',
  },
];